import { type Components } from '@mui/material';
import { HorizonTheme } from './horizon-theme';

export const muiDialogTitle: Components<HorizonTheme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: 'inherit',
      color: theme.palette.black.main,
      fontWeight: 600,
      fontSize: 18,
    }),
  },
};
